// extracted by mini-css-extract-plugin
export var video = "dummy-video-card-module--video--Fngcs";
export var title = "dummy-video-card-module--title--3Z-Cf";
export var info = "dummy-video-card-module--info--2DmfI";